import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function crb(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@crb/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@crb/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@crb/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@crb/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@crb/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@crb/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}